<template>
  <svg :width="width"
       :height="height"
       role="presentation"
       viewBox="0 0 70 81"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
       @click="$emit('click')">
    <path d="M38.6737 22.6572H2.86472C1.28196 22.6572 0 23.9124 0 25.4589V77.7577C0 79.3042 1.28196 80.5593 2.86472 80.5593H38.6737C40.2551 80.5593 41.5385 79.3042 41.5385 77.7577V25.4589C41.5385 23.9124 40.2551 22.6572 38.6737 22.6572ZM16.3518 26.1593H25.1838C25.8441 26.1593 26.3784 26.6818 26.3784 27.3262C26.3784 27.9706 25.8441 28.4931 25.1838 28.4931H16.3518C15.6915 28.4931 15.1572 27.9706 15.1572 27.3262C15.1572 26.6818 15.6915 26.1593 16.3518 26.1593ZM20.7692 77.0572C19.2524 77.0572 18.022 75.8539 18.022 74.3718C18.022 72.8884 19.2524 71.6864 20.7692 71.6864C22.2861 71.6864 23.5136 72.8884 23.5136 74.3718C23.5136 75.8539 22.2861 77.0572 20.7692 77.0572ZM36.5252 69.3526H5.01326V31.0622H36.5252V69.3526Z" :fill="disabled ? disabledStateColor : iconColor"/>
    <path d="M66.0666 0H17.0095C15.2625 0 13.8457 1.41917 13.8457 3.16733V18.9845H19.3861V9.502H63.6941V52.7852H45.4234V65.4545H66.0666C67.8135 65.4545 69.2303 64.0354 69.2303 62.2886V3.16733C69.2317 1.41917 67.8135 0 66.0666 0ZM22.5485 6.63161C21.5928 6.63161 20.8182 5.85511 20.8182 4.89877C20.8182 3.94244 21.5942 3.16873 22.5485 3.16873C23.5069 3.16873 24.2787 3.94383 24.2787 4.89877C24.2787 5.85511 23.5069 6.63161 22.5485 6.63161Z" :fill="disabled ? disabledStateColor : iconColor"/>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>